import React from "react";

const Catchall = () => (
  <>
    <h1>501: Not implemented, yet.</h1>
  </>
);

export default Catchall;
